/**
 * This constants file needs to be update if the page location under /app changes
 */
const PageConstants = {
    REGISTER: '/register',
    CHARGER: '/charger',
    ADOPT: '/adopt',
    PROFILE: '/profile',
}

export default PageConstants;